// extracted by mini-css-extract-plugin
export default {"sticky":"lib-component-mappings-sky-parallax-components-StickyComponent-StickyComponent__sticky--vJP2L"};